<app-header-component [headerData] = "currentHeaderData" (closeModal)="closeModal()"></app-header-component>

<ion-content>
  <ion-grid *ngIf="userGuestList?.length === 0; else showList" class="ion-text-center v-center">
    <ion-row>
      <ion-col size="12">
        <ion-label class="font14 font500 desc-text-color"
          >{{"shared.user_guest_list.your_requested_data_is_not_available" | translate}}</ion-label
        >
      </ion-col>
    </ion-row>
  </ion-grid>
  <ng-template #showList>
    <div *ngIf="userGuestList.length > 0">
      <ion-list class="ion-padding-end ion-list-transparent-bg-color">
        <ion-item
          *ngFor="let item of userGuestList"
          (click)="selectGuest(item)"
          class="ion-item-transparent-bg-color"
        >
          <ion-label>
            <p class="font14 font500 guest_name paragraph-primary-text-color">
              {{ item.firstName }} {{ item.lastName }}
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
    </div>
  </ng-template>
</ion-content>
